import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Card } from '../../../../../../packages/utx-access-client/src/react';

export interface IssueCardModalProps {
  onLayout: (event: any) => void;
}

export enum IssueCardStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Placed = 'placed'
}

export type IssueCardStackParamList = {
  [IssueCardStackRoutes.Main]: IssueCardModalProps & {
    account: string;
    tab?: number;
    onData: (data: any) => void;
    record?: any;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [IssueCardStackRoutes.Confirm]: IssueCardModalProps & {
    account: string;
    tab?: number;
    record?: any;
    data: any;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [IssueCardStackRoutes.Placed]: IssueCardModalProps & {
    account: string;
    tab?: number;
    record?: any;
    data?: any;
    returnData?: any;
    refresh?: () => void;
  };
};

export type IssueCardStackScreenProps<Screen extends keyof IssueCardStackParamList> = NativeStackScreenProps<
  IssueCardStackParamList,
  Screen
>;
